
import React, {useState, useEffect, useReducer} from 'react'
import {useApi} from "../ApiSession";
import {DefaultButton} from "../widgets/Buttons";
import ModalWindow from "../widgets/ModalWindow";
import {IndeterminateProgressBar} from "../widgets/ProgressBar";



const preRunReducer = (state, action) => {
    switch (action.name) {
        case "init": {
            return {
                preRunResults: {
                    status: action.pipelineInstance.preRunStatus,
                }
            }
        }
        case "startPrepare": {
            return {
                ...state,
                modalOpen: true,
                preRunResults: {
                    status: "running"
                },
            }
        }
        case "closePreRunModal": {
            return {
                ...state,
                modalOpen: false
            }
        }
        case "preRunResults": {
            return {
                ...state,
                preRunResults: {
                    status: action.res.status,
                    error: action.res.error,
                    preRunTasks: action.res.preRunTasks
                }
            }
        }
    }
}


export default  ({pipelineInstance, isReady, onReceivePreRunResponse}) => {

    const api = useApi()

    const [preRunView, preRunDispatch] = useReducer(
        preRunReducer,
        {},
        () => preRunReducer(null, {name: 'init', pipelineInstance})
    )


    const preRun = () => {

        preRunDispatch({name: 'startPrepare'})
        api.preRunPipelineInstance(pipelineInstance.pid).then(res => {
            if (onReceivePreRunResponse) onReceivePreRunResponse(res)
            preRunDispatch({name: "preRunResults", res})

        })
    }

    const closePreRunModal = () => preRunDispatch({name: 'closePreRunModal'})

    const displayFailedTasks = preRunTasks => {

        const outs = preRunTasks.map(t => t.web_gasket_error_messages || t.out)

        return <pre>{outs}</pre>
    }

    const isPreRunCompleted = () =>
        preRunView.preRunResults.status === "completed"


    const preRunModal = () => <ModalWindow
        title={"Preparing Pipeline"}
        onClose={closePreRunModal}
        largeGrid={true}
        footer={<DefaultButton caption={"Close"} onClick={closePreRunModal}/>}
    >
        {preRunView.preRunResults.status === "running" && <div className={"p-2"}>
            ... preparing pipeline instance
            <IndeterminateProgressBar/>
        </div>}

        {preRunView.preRunResults.status === "error" && <div className={"p-2"}>
            <div>Error while preparing pipeline</div>
            {displayFailedTasks(preRunView.preRunResults.preRunTasks)}
        </div>}

        {isPreRunCompleted() && <div className={"p-2"}>The pipeline is now prepared, and can be started.</div>}

    </ModalWindow>

    return <>
        <DefaultButton caption={isPreRunCompleted() ? "prepare complete" : "prepare"} onClick={preRun} isDisabled={isPreRunCompleted() || (!isReady)}/>
        {preRunView.modalOpen && preRunModal()}
    </>
}